import React from 'react';
import { Textarea as MantineTextarea, TextareaProps as MantineTextareaProps, Text, Stack, MantineTheme } from '@mantine/core';

interface TextAreaProps extends Omit<MantineTextareaProps, 'onChange'> {
  label?: string;
  error?: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  showCharacterCount?: boolean;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  error,
  description,
  value,
  onChange,
  maxLength,
  showCharacterCount = false,
  ...props
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.currentTarget.value;
    if (maxLength && newValue.length > maxLength) return;
    onChange(newValue);
  };

  const characterCount = value?.length || 0;
  const isNearLimit = maxLength ? characterCount >= maxLength * 0.9 : false;
  const characterCountColor = isNearLimit ? (characterCount === maxLength ? 'red' : 'orange') : 'dimmed';

  return (
    <Stack spacing="xs">
      <MantineTextarea
        label={label}
        error={error}
        description={description}
        value={value}
        onChange={handleChange}
        {...props}
        styles={(theme: MantineTheme) => ({
          root: {},
          wrapper: {},
          input: {
            minHeight: props.minRows ? undefined : 120,
          },
          label: {
            marginBottom: theme.spacing.xs,
            fontWeight: 500,
          },
          error: {
            marginTop: theme.spacing.xs,
          },
          description: {
            marginTop: theme.spacing.xs,
          },
        })}
      />
      {(showCharacterCount || maxLength) && (
        <Text 
          size="xs" 
          color={characterCountColor}
          align="right"
          mt={-8}
        >
          {maxLength ? `${characterCount}/${maxLength}` : characterCount} characters
        </Text>
      )}
    </Stack>
  );
};

export default TextArea; 